import { callApiToServer } from "../callApi";

export async function deleteVendor(authtoken, vendorId) {
  try {
    let header = {
      Accept: "application/json",
      "Content-Type": "application/json",
      authorization: "Berear " + authtoken,
    };

    let body = JSON.stringify({
      vendorId: vendorId,
    });

    let endUrl = "v1/auth/vendor";
    console.log("endUrl printed here", endUrl);

    let responseData = await callApiToServer(body, header, "DELETE", endUrl);

    return responseData;
  } catch (err) {
    throw err;
  }
}
